export default "__VITE_PUBLIC_ASSET__6525337e__"